module.exports = __webpack_public_path__ + "static/img/6.d51c7a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/20/zh/6.png
// module id = aEqf
// module chunks = 0